module.exports = __webpack_public_path__ + "static/img/warn.13f05b5f.svg";